import PropTypes from 'prop-types';
import React from 'react';

import {
  Breadcrumb,
  Spinner,
  Classes,
} from '@blueprintjs/core'
import { EDIT_MODE } from './constants'
import {
  PopContainer,
  PopRender,
  Callout,
  ActionMenu,
  Action,
  Table,
  Col,
} from '~/components/blueprint'
import service from '~/services/otherPaymentInstrumentService'
import EditDialog from './EditDialog'

import './pms.scss'

class PMS extends React.Component {
  constructor(props){
    super(props)
    this.toggle = this.toggle.bind(this)
    this.cleanAction = this.cleanAction.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
    this.submit = this.submit.bind(this)
    this.state = {
      loading: false,
      pmsList: [],
      active: null,
      action: null,
      error: null,
    }
  }
  componentWillMount(){
    this.fetchPMS()
  }
  async fetchPMS(){
    this.setState({loading: false})
    try {
      let {payment_instruments:pmsList} = await service.getAllWithDefalut(this.props.params.store_id)
      this.setState({pmsList, error: null})
    } catch (e) {
      this.setState({error: e})
    } finally {
      this.setState({loading: false})
    }
  }
  toggle(active){
    this.setState({active})
  }
  handleActionClick(target, mode){
    this.setState({
      action: {
        target,
        mode,
      }
    })
  }
  cleanAction(){
    this.setState({action: null, active: null})
  }
  async submit(data){
     await service.modifyAllWithDefault(this.props.params.store_id, {payment_instruments:[data]})
     this.cleanAction()
     this.fetchPMS()
  }
  render(){
    let { active, action, pmsList, loading, error } = this.state
    if (loading){
      return (
        <div className="bp pms main-content state-wrapper">
          <Spinner className={Classes.LARGE}/>
        </div>
      )
    }
    if (error){
      return (
        <div className="bp pms main-content state-wrapper">
          <Callout error={error}/>
        </div>
      )
    }
    return (
      <PopContainer className="bp pms">
        <div className="main-content">
          <ul className="pt-breadcrumbs">
            <li><Breadcrumb disabled text="Home"/></li>
            <li><Breadcrumb disabled text="Settings"/></li>
            <li><Breadcrumb text="PMS"/></li>
          </ul>
          <Table data={pmsList}>
            <Col field="name" title="Name"/>
            <Col field="tipping_enabled" title="Tipping" type="tick"/>
            <Col field="shortcut_enabled" title="Shortcut in Register Page" type="tick"/>
            <Col field="to_pms_enabled" title="PMS - Post to Room" type="tick"/>
            <Col field="room_number" title="Post to Room Number" empty=" - "/>
            <Col style={{width: '10%'}} render={
              (pms) => (
                <ActionMenu
                  active={active}
                  target={pms}
                  onToggle={this.toggle}
                  onActionClick={this.handleActionClick}
                >
                  <Action text="Edit" action={EDIT_MODE.EDIT}/>
                </ActionMenu>
              )
            }/>
          </Table>
          {action?(
            <PopRender
              title="PMS Configuration"
              isOpen={ action.mode === EDIT_MODE.EDIT }
              onClose={this.cleanAction}
            >
              <EditDialog model={ action.target } onSave={ this.submit } onCancel={ this.cleanAction }/>
            </PopRender>
          ):null}
        </div>
        <div className="main-content-header">
          <span className="title">PMS Configuration</span>
        </div>
      </PopContainer>
    )
  }
}

PMS.propTypes = {
  params: PropTypes.object,
}

export default PMS



/** WEBPACK FOOTER **
 ** ./client/pages/settings/pms/index.js
 **/